import { memo } from 'react';
import TrendLineInfoWidget from '../Widgets/TrendLineInfoWidget';
import { OvertimeCard, OvertimeSeries } from './utils/pipelineChartUtils';

const DEFAULT_SERIES: OvertimeSeries[] = [
  { name: 'Total', yAxisIndex: 1, data: [] },
  { name: 'Successful', data: [] },
  { name: 'Failed', data: [] },
  { name: 'Aborted', data: [] },
  { name: 'In Progress', data: [] },
  { name: 'Delayed', data: [] },
];

interface RunOvertimeTrendProps {
  xAxisData?: string[];
  series?: OvertimeSeries[];
  cards?: OvertimeCard[];
  isLoading?: boolean;
  isCardsLoading?: boolean;
}

const RunOvertimeTrendComponent = ({
  xAxisData = [],
  series = [],
  cards = [],
  isLoading = false,
  isCardsLoading = false,
}: RunOvertimeTrendProps) => {

  const finalSeries = series?.length ? series : DEFAULT_SERIES;
  const finalXAxis = xAxisData ?? [];


  return (
      <TrendLineInfoWidget
        title="Run Trends"
        xAxisData={finalXAxis}
        series={finalSeries}
        cards={cards}
        isCardsLoading={isCardsLoading}
        isLoading={isLoading} 
      />
  );
};

const RunOvertimeTrend = memo(RunOvertimeTrendComponent);

export default RunOvertimeTrend;